import React from "react";
import { Link } from "react-router-dom";
import Button from "../components/atoms/Button";

/**
 * NotFound - 404 page component
 */
function NotFound() {
  return (
    <div className="min-h-screen bg-[#0f1418] flex flex-col items-center justify-center p-4">
      <div className="animate-in fade-in duration-500 text-center">
        <div className="text-[#4db1e0] text-9xl mb-4">404</div>
        <h1 className="text-2xl font-bold text-white mb-6">Page Not Found</h1>
        <p className="text-gray-300 mb-8 max-w-md">
          The page you are looking for doesn't exist or has been moved.
        </p>
        <Link to="/">
          <Button variant="primary">Return to Dashboard</Button>
        </Link>
      </div>
    </div>
  );
}

export default NotFound;
